import { render, staticRenderFns } from "./tablesummary.vue?vue&type=template&id=115976b3&scoped=true&"
import script from "./tablesummary.vue?vue&type=script&lang=js&"
export * from "./tablesummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115976b3",
  null
  
)

export default component.exports